import CTAGroup from "@/components/CTAGroup";

export default function FinalCTA({
    eyebrow = "Get started",
    heading = "Let's prepare the right next step.",
    body = "Share a few details about your organization. The HR Connect will use it to prepare a custom proposal or set up a representative conversation.",
    align = "center",
    testIdPrefix = "final-cta",
}) {
    const al = align === "center" ? "items-center text-center" : "items-start";
    return (
        <section className="section bg-surface-alt/60 border-y border-border" data-testid={`${testIdPrefix}-section`}>
            <div className={`container-narrow flex flex-col gap-7 ${al}`}>
                <p className="eyebrow">{eyebrow}</p>
                <h2 className="h2 max-w-3xl">{heading}</h2>
                <p className="lead max-w-2xl">{body}</p>
                <CTAGroup align={align} testIdPrefix={testIdPrefix} />
            </div>
        </section>
    );
}
